import React from 'react';
import Scraper from './Scraper';
import http from '../../../../../../../utils/http';
import evemts from 'utils/evemts';

class ScraperContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      airlineList: [],
      Scraper: []
    };
    this.eventSource = null;
  }
  componentDidMount() {
    this.fetchScraper();
    this.eventSource = evemts('admin', 'import');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
    
      if (msg.data && msg.action && msg.action == 'airline_config') {
        if(msg.data.type != 'scraper') return;
        let findIndex = this.state.Scraper.findIndex((status) => status.airlineId == msg.data.airlineId);
        if (findIndex > -1) {
          let Scraper = [...this.state.Scraper];
          Scraper[findIndex] = msg.data;
          this.setState({ Scraper });
        } else {
          this.setState({ Scraper: [...this.state.Scraper, msg.data] });
        }
      }
    };
        
  }

  componentWillUnmount() {
    if (this.eventSource) {
      this.eventSource.close();
    }
  }

  fetchAirlines = () => {
    http.get('/airline')
      .then((response) => {
        // handle success
        this.setState({ airlineList: response.data.data });
      })
      .catch((error) => {
        // handle error
        console.error('Error fetching airlines:', error);
      });
  };

  fetchScraper = () => {
    http.get('/airline_config?type=' + 'scraper')
      .then((response) => {
        // handle success
        this.setState({ Scraper: response.data.data }, () => {
          this.fetchAirlines();
        });
      })
      .catch((error) => {
        // handle error
        console.error('Error fetching scraper:', error);
      });
  };
  onChange = (event) => {
    const { name, checked } = event.target;
    http.post('/airline_config', {
      airlineId: name,
      type: 'scraper',
      value: checked
    });
  };

  render() {
    return (
      <Scraper airlineList={this.state.airlineList} Scraper={this.state.Scraper} onChange={this.onChange} />
    );
  }
}

export default ScraperContainer;